/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_SubInputs */

const en_mk_price_sub = /** @type {(inputs: Mk_Price_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices and allowances below come from Bystep’s active plan catalog. Choose your currency and review the details before subscribing.`)
};

const id_mk_price_sub = /** @type {(inputs: Mk_Price_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga dan kuota di bawah mengikuti katalog paket aktif Bystep. Pilih mata uang, lalu lihat rincian sebelum berlangganan.`)
};

/**
* | output |
* | --- |
* | "Prices and allowances below come from Bystep’s active plan catalog. Choose your currency and review the details before subscribing." |
*
* @param {Mk_Price_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_sub = /** @type {((inputs?: Mk_Price_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_sub(inputs)
	return en_mk_price_sub(inputs)
});